import { BsFiletypeHtml, BsFiletypeCss, BsBootstrap } from "react-icons/bs";
import { FaAws } from "react-icons/fa6";

import { FaNodeJs } from "react-icons/fa";
import {
  SiJavascript,
  SiReact,
  SiMongodb,
  SiMysql,
  SiPostman,
  SiGithub,
  SiNetlify,
  SiExpress,
  SiRender
} from "react-icons/si";
export const TechstackList = [
  {
    _id: 1,
    name: "HTML",
    icon: BsFiletypeHtml,
  },
  {
    _id: 2,
    name: "CSS / SCSS",
    icon: BsFiletypeCss,
  },
  {
    _id: 3,
    name: "Bootstrap",
    icon: BsBootstrap,
  },
  {
    _id: 4,
    name: "Javascript",
    icon: SiJavascript,
  },
  
  {
    _id: 5,
    name: "React JS",
    icon: SiReact,
  },
  {
    _id: 6,
    name: "Node JS ",
    icon: FaNodeJs,
  },
  {
    _id: 7,
    name: "Express JS ",
    icon: SiExpress,
  },
  {
    _id: 8,
    name: "Mongodb ",
    icon: SiMongodb,
  },
  {
    _id:9,
    name:"Postman",
    icon:SiPostman
  },
  {
    _id: 10,
    name: "SQL ",
    icon: SiMysql,
  },
{
    _id: 11,
    name: "Git / Github ",
    icon: SiGithub,
  },
  {
    _id:12,
    name:"AWS",
    icon:FaAws,
  },
  {
 _id:13,
 name:"Netlify",
 icon:SiNetlify
  },
  {
    _id:14,
    name:"Render",
    icon:SiRender
   
  }


  ];